interface SkiTestMenuProps {
  price: number;
  handle: string;
}

export function SkiTestMenu({price, handle}: SkiTestMenuProps) {
  return (
    <div className="relative ski-test-menu bg-blue-400 text-white p-3 py-5 text-center text-sm font-medium flex flex-col md:flex-row gap-4 md:gap-12 justify-center items-center">
      <span className="hidden md:inline">
        <a href="#st-specs">Specs</a>
      </span>
      <span className="hidden md:inline">
        <a href="#st-testers">Testers</a>
      </span>
      <span className="hidden md:inline">
        <a href="#st-gallery">Gallery</a>
      </span>
      <span className="hidden md:inline">
        <a href="#st-video">Video</a>
      </span>
      <span className="hidden md:inline">
        <a href="#ski-comments">Comments</a>
      </span>
      <div className="lg:absolute lg:right-16 flex-grow-1">
        <a
          href={`/products/${handle}`}
          className="font-sans bg-red-400 text-white text-sm leading-none font-bold px-6 py-3 rounded-full uppercase flex gap-2 items-center"
        >
          <span>Buy Now</span>
          <span>|</span>
          <span>${price}</span>
        </a>
      </div>
    </div>
  );
}
